import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { API, AUTH } from '@const'
import Button from '@material-ui/core/Button'
import * as utils from '@utils'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import Table from '@tables/table'

class CmsManagementPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'CmsManagementPage')
        }
    }

    state = {
        roleMap: {},
    }

    columns = [
        { field: 'account' },
        {
            field: '所屬總代理',
            render: (rowData) => (rowData['root_role_id'] === AUTH.ROLE_ID_ADMIN ? 'RICH88' : this.state.roleMap[rowData['root_role_id']]['name']),
        },
    ]

    componentDidMount() {
        this.queryRoleData(this.queryData)
    }

    queryData = (showToast) => {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.SYSTEM_CMS_USER_ONLINE_LIST,
            {},
            (data) => {
                this.table.SetData(data)
            },
            (_err) => {},
            !showToast
        )
    }

    queryRoleData(callback) {
        utils.apiRequest(
            'get',
            API.ROLE_LIST,
            {},
            (data) => {
                this.setState(
                    {
                        roleMap: utils.ArrayToObject(data, 'id'),
                    },
                    callback
                )
            },
            (_err) => {
                this.setState({
                    roleList: {},
                })
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Button variant="contained" onClick={() => this.queryData(false)} color="primary" style={{ marginRight: '12px' }}>
                        {'重新整理'}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Table ownerName="CmsManagementPage" columns={this.columns} onRef={(ref) => (this.table = ref)} />
                </Grid>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {}
}

CmsManagementPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default hoc(styles)(CmsManagementPage)
